import http from "./httpService";
import { apiUrl } from "../config";

//export const getClaims = (searchDto) => http.post(`${apiUrl}claimtrans/ViewClaims`, searchDto);

export const getClaims = () => http.post(`${apiUrl}claimtrans/ViewClaims`);

export const getClaim = (transId) =>
  http.get(`${apiUrl}claimtrans/ViewClaimsDescription`, {
    params: { transId },
  });

export const postClaim = (claimRequest) => {
  return http.post(`${apiUrl}claimtrans/PostClaim`, claimRequest, {
    // responseType: "blob",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getExportedClaims = () =>
  http.get(`${apiUrl}claimtrans/ExportClaims`, { responseType: "blob" });
